module.exports = __webpack_public_path__ + "static/media/Vue-SDB_05-Bleu-ecume-bleu-profond-2.2b24bac9.jpg";